import React from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import { Modal } from 'antd'
import { ModalStyle } from './ModalStyle'

const BasicModal = (props) => {
  const handleClose = () => {
    props.onClose && props.onClose()
  }

  const portalDiv = document.getElementById('root')!

  return (
    props.isOpen &&
    document.getElementById('root') &&
    createPortal(
      <Modal
        open={props.isOpen}
        centered
        onOk={handleClose}
        onCancel={handleClose}
        closable={false}
        footer={[
          <div key="back" className="text-center">
            <ButtonOk onClick={handleClose} className="btn-ok">
              閉じる
            </ButtonOk>
          </div>,
        ]}
        className="basic-modal"
      >
        <ModalStyle>{props.children}</ModalStyle>
      </Modal>,
      portalDiv,
    )
  )
}

const ButtonOk = styled.div`
  color: #000;
  font-weight: 700;
  font-size: 18px;
  border: unset;
  background-color: unset;
`

export default BasicModal
